<div class="actions">
    <p-button
        [label]="'users-importer.import' | translate"
        icon="pi pi-upload"
        [loading]="importing()"
        data-test="schools-import-learners-import"
        (onClick)="onImportClick()"
    />
    <p-button
        [label]="'users-importer.downloadTemplate' | translate"
        icon="pi pi-download"
        severity="secondary"
        [outlined]="true"
        [loading]="downloadingTemplate()"
        data-test="schools-import-learners-download-template"
        (onClick)="onDownloadTemplate()"
    />
    <input #fileInput type="file" accept=".csv,text/csv" hidden data-test="schools-import-learners-file-input" (change)="onFileSelected($event)" />
</div>

<p class="hint">{{ 'users-importer.hint' | translate }}</p>

@if (summary(); as summary) {
    <div class="summary">
        <div class="summary-header">
            <h3>{{ 'users-importer.summary.title' | translate }}</h3>
            <button
                class="close"
                type="button"
                [attr.aria-label]="'common.close' | translate"
                data-test="schools-import-learners-close-summary"
                (click)="onClearSummary()"
            >
                <i class="pi pi-times"></i>
            </button>
        </div>

        <div class="counts">
            <div class="count">
                <span class="count-label">{{ 'users-importer.summary.total' | translate }}</span>
                <span class="count-value">{{ summary.totalRows }}</span>
            </div>
            <div class="count created">
                <span class="count-label">{{ 'users-importer.summary.created' | translate }}</span>
                <span class="count-value">{{ summary.created }}</span>
            </div>
            <div class="count skipped">
                <span class="count-label">{{ 'users-importer.summary.skipped' | translate }}</span>
                <span class="count-value">{{ summary.skipped }}</span>
            </div>
            <div class="count failed">
                <span class="count-label">{{ 'users-importer.summary.failed' | translate }}</span>
                <span class="count-value">{{ summary.failed }}</span>
            </div>
        </div>

        @if (issues().length > 0) {
            <ul class="issues">
                @for (issue of issues(); track issue.row) {
                    <li class="issue" [class.skipped]="issue.status === 'skipped'" [class.failed]="issue.status === 'failed'">
                        <div class="issue-head">
                            <span class="row">{{ 'users-importer.summary.row' | translate: { row: issue.row } }}</span>
                            <span class="email">{{ issue.email }}</span>
                            <span class="status">{{ issue.status ? ('users-importer.summary.status.' + issue.status | translate) : '-' }}</span>
                        </div>
                        @if (issue.reason) {
                            <p class="reason">{{ issue.reason }}</p>
                        }
                        @if (issue.errors.length > 0) {
                            <ul class="errors">
                                @for (error of issue.errors; track $index) {
                                    <li>
                                        <strong>{{ error.field }}:</strong> {{ error.message }}
                                    </li>
                                }
                            </ul>
                        }
                    </li>
                }
            </ul>
        }
    </div>
}
